import { addMonths, compareAsc, subDays } from "date-fns";
import * as Yup from "yup";
import { decretoEnum, preguntaHabilitantePlanillaAPorDecreto } from "../../../commons/enums/RgrlEnums";

export const decretosFormValidation = (requerirActividad) => (
  Yup.object().shape({
    idActividad: Yup.string().nullable().when([], {
      is: () => { return requerirActividad },
      then: (schema) => schema.required("Campo Obligatorio"),
    }),
    totalTrabajadoresEstablecimientos: Yup.number("Solo se permiten números")
      .positive("No se permiten valores menores a 1")
      .integer("No ingresar caracteres")
      // en la tabla del back totalTrabajadoresEstablecimientos es un int
      .max(2147483647, "No puede ingresar números mayores a 2.147.483.647")
      .nullable()
      .typeError("No ingresar caracteres")
      .required("Campo obligatorio"),
    totalEstablecimientos: Yup.number("Solo se permiten números")
      .positive("No se permiten valores menores a 1")
      .integer("No ingresar caracteres")
      // en la tabla del back totalEstablecimientos es un smallint
      .max(32767, "No puede ingresar números mayores a 32.767")
      .nullable()
      .typeError("No ingresar caracteres")
      .required("Campo obligatorio"),
    superficie: Yup.string()
      .test("negative", "El valor debe ser mayor a 0", value => {
        if (value) {
          return !value.includes('-') && parseInt(value) > 0;
        }
        return true;
      })
      .matches(/^[0-9]+(,[0-9]+)?$/, "Solo ingrese comas y números")
      .test({
        // en la tabla del back totalEstablecimientos es un decimal(10, 2)
        name: "cantidadDigitosDecimales",
        message: "Máximo 2 dígitos después de la coma",
        test: function (value) {
          if (value?.includes(",")) {
            return value?.match(/^[0-9]+(,\d{1,2})?$/);
          } else {
            return true;
          }
        },
      })
      .test({
        name: "cantidadTotalDigitos",
        message: "Máximo 8 dígitos enteros",
        test: function (value) {
          return value?.split(",")[0]?.length <= 8;
        },
      })
      .nullable()
      .typeError("No ingresar caracteres")
      .required("Campo obligatorio"),
    observaciones: Yup.string()
      .max(100, "Máximo permitido: 100 caracteres")
      .optional(),
  })
);





const preguntaDependienteDe = (resultado, secuenciaEsperada, secuencia, dependenciasPregunta, preguntas) => {
  return secuenciaEsperada === secuencia && resultado !== "1" && preguntas.some((p) => {
    return (dependenciasPregunta.includes(p.secuencia) && p.resultado !== 2)
  });
}

export const validatePreguntaTable = (decretoActual, preguntasDecreto) => {
  const preguntas = preguntasDecreto.flat()
    .map((a) => a.itemsFormularioArt)
    .flat();
  return (
    Yup.object({
      itemsFormularioArt: Yup.array().of(
        Yup.object().shape({
          resultado: Yup.string().nullable().required("Debes seleccionar una respuesta").test(({
            name: "validacionPlanillaA",
            message: ``,
            test: function (value, testContext) {
              switch (decretoActual) {
                case decretoEnum.decreto351:
                  if (preguntaDependienteDe(value, testContext.parent.secuencia, preguntaHabilitantePlanillaAPorDecreto.decreto351, [87, 88, 89, 90, 93, 94, 95, 96, 97, 98, 99, 100, 147, 148, 149], preguntas)) {
                    return testContext.createError({ path: testContext.path, message: "Al tener marcada alguna de las preguntas de los grupos 'Radiaciones Ionizantes', 'Radiaciones no Ionizantes' o 'Soldadura'  como 'Sí'/'No' corresponde marcar esta pregunta como 'Sí'" })
                  }
                  break;
                case decretoEnum.decreto911:
                  if (preguntaDependienteDe(value, testContext.parent.secuencia, preguntaHabilitantePlanillaAPorDecreto.decreto911, [199], preguntas)) {
                    return testContext.createError({ path: testContext.path, message: "Al tener marcada alguna de las preguntas del grupo 'Soldadura y corte de gas' como 'Sí'/'No' corresponde marcar esta pregunta como 'Sí'" })
                  }
                  break;
                case decretoEnum.decreto617:
                  break;
                default: return true;
              }
              return true;
            }
          })),
          fechaRegulacion: Yup.date()
            .nullable()
            .when("resultado", {
              is: "0",
              then: Yup.date()
                .min(
                  subDays(new Date(), 1),
                  "La fecha  de regulación no puede ser menor a la fecha de hoy"
                )
                .typeError("Fecha inválida")
                .nullable()
                .required("La fecha de regulación es requerida")
                .test({
                  name: "valorMaximoFecha",
                  message:
                    "La fecha de regulación no puede ser mayor a 15 meses de la fecha de presentación",
                  test: function (value) {
                    // Compare the two dates and return
                    // 1 if the first date is after the second,
                    // -1 if the first date is before the second
                    // or 0 if dates are equal.
                    if (compareAsc(addMonths(new Date(), 15), value) >= 0) {
                      return true;
                    }
                    return false;
                  },
                })
            }),
        })
      ),
    }))

};

export const validateRequiredFields = (values, model) => {
  const errors = {};
  const errorMessage = "Campo obligatorio";

  for (var value in values) {
    //valida que el campo exista en los datos de la nomina para validar su obligatoriedad
    if (model[value]) {
      if (model[value].obligatorio && !values[value]) {
        errors[value] = errorMessage;
      }
    }
  }

  return errors;
};
